import './style.scss'

import React from 'react'

import NoEmptyLegMatchesIllustration from '../../assets/no-empty-leg-matches.svg?react'
import { ResetSearchButton } from '../ResetSearchButton/ResetSearchButton'

type NoMatchesStateProps = {
    title: string
    description: string
    onResetSearch: () => void
}

export const NoMatchesState = ({ title, description, onResetSearch }: NoMatchesStateProps) => (
    <section className="public-empty-legs__no-matches">
        <div className="public-empty-legs__no-matches-content">
            <NoEmptyLegMatchesIllustration
                className="public-empty-legs__no-matches-image"
                aria-hidden="true"
                focusable="false"
            />
            <h2>{title}</h2>
            <p>{description}</p>
            <ResetSearchButton
                className="public-empty-legs__reset-search"
                onClick={onResetSearch}
            />
        </div>
    </section>
)
